export class ComplaintStatusSearchModel {
    constructor(data = {}) {
        this.email = data.email ?? '';
        this.lastName = data.lastName ?? '';
        this.complaintId = data.complaintId ?? '';

        // response fields
        this.complaintStatus = data.complaintStatus ?? null;
        this.complaintOutcome = data.complaintOutcome ?? null;

        this.error = data.error ?? '';
    }
}
